import React, { useState } from "react";
import { Link } from "react-router-dom";
import TrailerViewer from "./trailerViewer";
import TrailerSlider from "./trailerSlider";
import * as api from "../lib/api";
import { isNotNullOrEmpty } from "../lib/utilities";
import BookFilters from "./bookFilters";

const Trailers = ({ title, tag, items, isSliderMode }) => {
  const [activeFilters, setActiveFilters] = useState({
    series: undefined,
    category: undefined,
  });

  const onFilterUpdate = (filters) => {
    setActiveFilters(filters);
  };

  const showOnly = isSliderMode ? 8 : 0;

  const getTrailerItems = () => {
    // when going to the trailers only page, the items are empty, so refetch
    if (!isNotNullOrEmpty(items)) {
      const availableBooks = api.getVisibleBooks();
      items = api.getTrailers(availableBooks);
    }

    if (activeFilters.series)
      items = api.getBooksBySeries(activeFilters.series, items);
    if (activeFilters.category)
      items = api.getBooksByCategory(activeFilters.category, items);

    const sortedItems = api.sortByPubDate(items);
    const itemsToShow =
      showOnly > 0 ? sortedItems.slice(0, showOnly) : sortedItems;

    return itemsToShow;
  };

  const trailerItems = getTrailerItems();

  return (
    <div className={`section ${!isSliderMode ? "contents" : ""}`}>
      <div className="heading" id={tag}>
        <h3>{title}</h3>
        {isSliderMode && <Link to="/trailers/all">View All</Link>}
      </div>
      <div className="content">
        {!isSliderMode ? (
          <div className="row">
            <div className="col">
              <BookFilters items={items} onFilterUpdate={onFilterUpdate} />
            </div>
          </div>
        ) : undefined}
        <div className="row">
          {isSliderMode ? (
            <div className="col">
              <TrailerSlider items={trailerItems} showOnly={showOnly} />
            </div>
          ) : (
            <>
              {trailerItems.map((item) => (
                <div className="col" key={item.id}>
                  <TrailerViewer itemId={item.id} videoId={item.trailerUrl} />
                  <div className="trailer-link">
                    <Link to={`/book/${item.id}`}>{item.title}</Link>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Trailers;
